import dayjs from 'dayjs'

export const isPaymentDeadlineExpired = (
  deadline: string | null,
  now: Date = new Date(),
): boolean => {
  if (!deadline) return false

  const deadlineDate = dayjs(deadline)

  return deadlineDate.isValid() && deadlineDate.isBefore(dayjs(now), 'day')
}
